document.getElementById('add-three-to-cart').addEventListener('click', function() {
  let productId = this.getAttribute('data-product-id'); // Gets the product ID from the button
  let quantity = 3; // The number of items to add

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: productId,
      quantity: quantity
    })
  })
  .then(response => {
    if (response.ok) {
      console.log('Product added successfully');
      // Optionally, redirect to the cart page or show a success message
    } else {
      console.error('Failed to add product');
    }
  });
});
